/**
 * represents various package types
 */
export enum PackageType {
  Box = 'Box',
  Envelope = 'Envelope',
  PredefinedPackage = 'PredefinedPackage',
}
